import { isRequiredFeatureEnabled } from 'src/components/auth';
import { TRootState } from 'src/store';
import { FeatureFlag } from 'src/types';
import { getUserCaseRole } from 'src/utils/analytics';

export const caseLinksPanel = (state: TRootState) => {
  const { caseById, caseLinks } = state.case;
  const segmentEnabled = isRequiredFeatureEnabled(
    state.features,
    FeatureFlag.FRONTEND_SEGMENT_TRACKING,
  );

  if (!caseById)
    return {
      caseId: '',
      caseReadableId: '',
      caseLinks: [],
      numberOfLinkedCases: 0,
      permissions: {
        canEditCaseDetails: false,
      },
      segmentEnabled,
      organisationId: null,
      userRole: null,
    };

  const { canEditCaseDetails } = caseById.AssociatedPermissions ?? {};

  return {
    caseId: caseById.id,
    caseReadableId: caseById.readableId,
    caseLinks: caseLinks ?? [],
    numberOfLinkedCases: caseLinks?.length ?? 0,
    permissions: {
      canEditCaseDetails: !!canEditCaseDetails,
    },
    segmentEnabled,
    organisationId: caseById.organisation,
    userRole: state.globalUsers.currentUser?.id
      ? getUserCaseRole(
          state.globalUsers.currentUser?.id,
          caseById.CaseTeam,
          caseById.CaseLead?.id,
          caseById.Reports ?? [],
        )
      : null,
  };
};
